// src/services/titService.js
import api from './api';

const getTokenizationApplications = (params = {}) => {
  return api.get('/manager/tokenization-applications', { params });
};

const updateTokenizationApplication = (applicationId, data) => {
  return api.put(`/manager/update-tokenization-application/${applicationId}`, data);
};

const applyTokenization = (artId, payload) => {
  return api.post(`/artwork/artwork-apply-tokenization/${artId}`, payload);
};

const getTokenizationApplicationsClient = (params = {}) => {
  return api.get('/artwork/artwork-tokenization-applications', { params });
};

const convertToTitTat = (artId, ownerId) => {
  return api.post(
    `/manager/tokenize-art`,
    null, // no body
    {
      params: {
        art_id: artId,
        owner_id: ownerId
      }
    }
  );
};

const getTitTats = (options = {}) => {
  const normalized = typeof options === 'string' ? { tokenId: options } : options;
  const { tokenId = null, cursor = null, limit = null, search = null } = normalized;
  return api.get('/manager/tokenized_art', {
    params: {
      ...(tokenId && { token_id: tokenId }),
      ...(cursor && { cursor }),
      ...(limit && { limit }),
      ...(search && { search }),
    }
  });
};

const getClientTokenizedArts = ({ tokenId = null, createdAt = null, cursor = null, limit = null } = {}) => {
  const params = {
    ...(tokenId && { token_id: tokenId }),
    ...(createdAt && { created_at: createdAt }),
    ...(cursor && { cursor }),
    ...(limit && { limit }),
  };

  if (!tokenId && !limit) {
    params.limit = 20;
  }

  return api.get('/artwork/tokens/tokenized-arts', {
    params
  });
};

export const pushTokenToBid = (tokenId) => {
  return api.post(`/artwork/artwork-token/bid-push/${tokenId}`);
};

const titService = {
  getTokenizationApplications,
  getTokenizationApplicationsClient,
  updateTokenizationApplication,
  applyTokenization,
  convertToTitTat,
  getTitTats,
  getClientTokenizedArts,
  pushTokenToBid
};

export default titService;
